export default "__VITE_ASSET__CeC_lQcs__"